/**
 * Scroll Utilities
 * @description 스크롤 관련 유틸리티 함수
 */

export interface ScrollArrowElements {
  list: HTMLElement;
  leftArrow: HTMLElement;
  rightArrow: HTMLElement;
}

const VISIBLE_CLASS = 'nde-c-side-menu__arrow--visible';
const SCROLLABLE_CLASS = 'nde-c-side-menu__container--scrollable';

/**
 * 스크롤 화살표 표시 상태 업데이트 (스크롤 이벤트마다 호출)
 */
export const updateScrollArrows = ({ list, leftArrow, rightArrow }: ScrollArrowElements): void => {
  const scrollLeft = list.scrollLeft;
  const maxScroll = list.scrollWidth - list.clientWidth;
  const hasOverflow = maxScroll > 0;

  const showLeft = scrollLeft > 5 && hasOverflow;
  const showRight = scrollLeft < maxScroll - 1 && hasOverflow;

  leftArrow.classList.toggle(VISIBLE_CLASS, showLeft);
  rightArrow.classList.toggle(VISIBLE_CLASS, showRight);
};

/**
 * 컨테이너 패딩 업데이트 (초기화/리사이즈에서만 호출)
 * 스크롤 중 패딩 변경은 smooth scroll과 충돌하므로 분리
 */
export const updateScrollPadding = ({ list }: Pick<ScrollArrowElements, 'list'>): void => {
  const container = list.parentElement;
  if (!container) {
    return;
  }

  // 현재 패딩을 제거한 상태에서 오버플로우 판단
  container.classList.remove(SCROLLABLE_CLASS);
  const hasOverflow = list.scrollWidth > list.clientWidth;
  container.classList.toggle(SCROLLABLE_CLASS, hasOverflow);
};

/**
 * 스크롤량 계산: 컨테이너 너비 기준 (최소 200px, 최대 400px)
 */
export const getScrollAmount = (element: HTMLElement): number => {
  const containerWidth = element.clientWidth;
  const MIN_SCROLL = 200;
  const MAX_SCROLL = 400;
  return Math.min(Math.max(containerWidth, MIN_SCROLL), MAX_SCROLL);
};

/**
 * 부드러운 스크롤
 */
export const smoothScroll = (element: HTMLElement, direction: 'left' | 'right', amount?: number): void => {
  const scrollAmount = amount ?? getScrollAmount(element);
  element.scrollBy({
    left: direction === 'left' ? -scrollAmount : scrollAmount,
    behavior: 'smooth',
  });
};
